<template >
    <div>

    <div class="card mb-4" v-for="(topic) in topics" v-if="topics!=null && topics.length>0">
        <div class="card-header py-3">
          <div class="row">
            <div class="col">
              <h5 class="m-0 font-weight-bold text-primary">{{languages[lang].topic}}: {{topic.name}}</h5>Товч нэр: <span style="font-weight:bold">{{topic.shortname}}</span>
            </div>
  
          </div>
        </div>
        <div class="card-body" >
          <p v-if="topic.description!=null && topic.description!=''">{{topic.description}}</p>
          <!-- <p style="color:red">Тайлбар ороогүй</p> -->
          <hr/>

 
          <div v-if="topic.tags!=null && topic.tags!=undefined && topic.tags.length>0">
            Түлхүүр үгс:
            <span class="badge badge-pill badge-success mr-2" v-for="(tag, ti) in topic.tags">
              {{tag}}
              <!-- <i class="fas fa-times ml-2" style="cursor:pointer" @click="removeTag(tag, ti)"></i> -->
            </span>
          </div>
          <div v-if='display==0'>
            <div class="row mt-4">
              <div class="col-md-4  mb-3" v-for="(item, index) in topic.details" v-bind:key="item.id" >
                <div class="card mycard" style="cursor:pointer" @click='goContentDetail(topic, item)'>
                  <div class="card-body">
                    <div class="row justify-content-between">
                       <div class="col-6">
                          <h6 class="card-title topicItemTitle text-ecllipsis">
                            {{index+1}}. {{item.name}}
                          </h6>
                        </div> 
                        <div class="col-6 text-right">
                          <span v-if="item.type=='lecture'" class="badge badge-warning" style="color:black">{{getType(item.type)}}</span>
                          <span v-else-if="item.type=='video'" class="badge badge-warning" style="color:black">{{getType(item.type)}}</span>
                          <span v-else-if="item.type=='seminar'" class="badge badge-warning" style="color:black">{{getType(item.type)}}</span>

                          <span v-else-if="item.type=='coursework'" class="badge badge-info" style="color:black">{{getType(item.type)}}</span>
                          <span v-else-if="item.type=='assignment'" class="badge badge-info" style="color:black">{{getType(item.type)}}</span>
                          
                          <span v-else-if="item.type=='test'" class="badge badge-danger">{{getType(item.type)}}</span>
                          <span v-else-if="item.type=='exam'" class="badge badge-danger">{{getType(item.type)}}</span>
                        </div>
                    </div>
                    <div class="card-text">
                      <div class="row">
                        <div class="col">
                          <p class="mb-1" v-if="item.duration">Xугацаа: <span class="font-weight-normal text-danger">{{item.duration}} минут</span></p>
                          <p class="mb-1" v-if="item.time">Xугацаа: <span class="font-weight-normal text-danger">{{item.time}} минут</span></p>
                        </div>
                      </div>
           
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="list-group" v-else>
            <div v-for="(item, index) in topic.details"  class="list-group-item list-group-item-action flex-column align-items-start ">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{index+1}}. {{item.name}}</h5>
                <div>
                  <small v-if="item.type!=null && item.type!=undefined">
                    {{item.type}}
                  </small>

                </div>
              </div>
              <p class="mb-1">{{item.description}}</p>
              <p class="mb-1" v-if="item.duration!=null">Үргэлжлэх хугацаа :{{item.duration}} минут</p>
              <div class="my-3">

               
                
              </div>
              <p class="mb-1" v-if="item.startDay!=null">Эхлэх: {{item.startDay | formatDate}}</p>
              <p class="mb-1" v-if="item.endDay!=null">Дуусах: {{item.endDay | formatDate}}</p>
              
              <ul>
                <li style="margin-bottom: 18px;"  v-if="item.videoUrl!=null">
                  <br/>

                  <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe>
                
                </li>
              </ul>

              


            </div>
           
          </div>
        </div>
      </div>


    </div>
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'
import firebase from 'firebase'
import lang from '../lang.js';

export default {
    name: "PublicTopics",

    data() {
        return {
            display:0,
            selectedTopic:null,
            content:{
              'name':null,
              'description':null,
              'videoUrl':null,
              'published':false,
              'startDay':null,
              'endDay':null,
              'code':null,
              'duration':null,
              'shortname':null
            },
            selectedType:null,
            selectedTopic:null

        };
    },
    mixins:[lang],

    methods: {
    
      goContentDetail(topic, content) {

          if(topic!=null && content!=null ){
            // if(content.type=="exam" || content.type=="test"){
              
            // }
            //   // this.$router.push({ name: 'IQuestions', params: {schoolId: this.schoolId, lessonId: this.lessonId, topicId: topic.id, detailId: content.id} });
            // else
              this.$router.push({ name: "StudentContentDetail", params: {lessonId: this.lessonId, topicId:topic.id, contentId: content.id, showContainer:true} });
          }
        
      },
      getType(type){
        if(!this.lang || this.lang=='mn'){
          if(type=="test")
            return "Тест давтлага";
          else if(type=="video")
            return "Хичээл";
          else if(type=="lecture")
            return "Хичээл";
          else if(type=="seminar")
            return "Семинар";
          else if(type=="exam")
            return "Шалгалт";
          else if(type=="homework")
            return "Гэрийн даалгавар";
          else if(type=="coursework")
            return "Бие даалт";
          else if(type=="assignment")
            return "Даалгавар";
        }
        else if(this.lang=='english'){
          return type;
        }
        
      },
      


    },
    computed: {
        ...mapState(['userProfile', 'currentUser', 'lang'])
    },
    props: {
        topics: { 
            required: true,
        },
        lesson:{
            required:true
        },
        types:{
            required:false
        },
        schoolId:{
            required:false
        },
        lessonId:{
            required:true
        },
        _editTopic:{
            required:false
        },
    },
    created() {
 
            
    },
    filters: {
		  formatDate(val) {
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).format('MM/DD/YYYY HH:mm');
      },
    }
  
};
</script>

